/* eslint-disable no-tabs */
import { Outlet } from 'react-router';

const EmptyLayout = () => (
	<Outlet />
);

export default EmptyLayout;
